import React from 'react';
import ToggleSwitch from '../../Forms/Input/ToggleSwitch';
import { ProductFormValues } from '../../../types/product/ProductFormValues';

interface Props {
  form: ProductFormValues;
  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductDiscountSection: React.FC<Props> = ({ form, onChange }) => (
  <div className="rounded-xl border border-stroke bg-gray-2 p-5 dark:border-strokedark dark:bg-meta-4/20">
    <ToggleSwitch
      label="Permitir descuentos en este producto"
      name="appliesDiscount"
      checked={form.appliesDiscount}
      onChange={() => onChange('appliesDiscount', !form.appliesDiscount)}
    />
    <p className="mt-2 pr-16 text-xs leading-5 text-bodydark2">
      Si se desactiva, este producto nunca recibirá descuento: ni un
      descuento manual puesto directamente en la línea, ni la parte que le
      correspondería del descuento global aplicado a la venta o cotización.
    </p>
  </div>
);

export default ProductDiscountSection;
